export default {
      id: "settings-usage",
      viewBox: "0 0 14 15",
      url: __webpack_public_path__ + "img/icons.adde2a28.svg#settings",
      toString: function () {
        return this.url;
      }
    }